import { GA4_EVENT_SCHEMAS } from "./validation/eventSchemas.js";

/**
 * Liste aller GA4 Events die per gtag.js an GA4 gesendet werden dürfen.
 *
 * Diese Events werden über den DataLayerService per gtag() gesendet.
 * Nur Events in dieser Liste werden per gtag() versendet - alle anderen per dataLayer.push().
 *
 * Kategorien:
 * - Standard Events: Offizielle GA4 Standard-Events (aus eventSchemas.js)
 * - Custom Events: Projekt-spezifische Custom Events
 */

/**
 * Standard GA4 Events und E-Commerce Events
 * Offizielle Events nach GA4 Standard-Spezifikation
 * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events
 */
export const STANDARD_EVENTS = Object.keys(GA4_EVENT_SCHEMAS);

/**
 * Custom Events
 * Projekt-spezifische Events die nicht im GA4 Standard enthalten sind
 */
export const CUSTOM_EVENTS = [
    // UI Interactions
    'copy',                         // Copy-to-Clipboard Events
    'dialog_view',                  // Dialog/Modal Views
    'form',                         // Form Interactions

    // Video Tracking
    'video_complete',               // Video wurde vollständig angesehen
    'video_progress',               // Video-Fortschritt bei 10%, 25%, 50%, 75%
    'video_start',                  // Video wurde gestartet

    // Search & Results
    'searchresults',                // Search Results View (legacy name)

    // A/B Testing
    'experience_impression',        // A/B Test Impression

    // Gebrauchtbuch-Flow (Used Books)
    'add_item_from_box',
    'book_confirmed_for_sale',
    'book_declined_by_user',
    'book_found',
    'book_not_found',
    'book_not_found_back_navigate',
    'book_not_found_continue_to_box',
    'book_rejected',
    'complete_sale',
    'proceed_to_checkout',
    'used_book_search',
    'view_shipping_box',

    // Third-Party Integrations
    'braze-in-app-message-view'     // Braze In-App Messages
];

/**
 * Vollständige Liste aller erlaubten GA4 Events
 */
export const ALLOWED_GA4_EVENTS = [
    ...STANDARD_EVENTS,
    ...CUSTOM_EVENTS
];

/**
 * Prüft ob ein Event-Name zu den erlaubten GA4 Events gehört
 * @param {string} eventName - Name des Events
 * @returns {boolean}
 */
export function isAllowedGA4Event(eventName) {
    return ALLOWED_GA4_EVENTS.includes(eventName);
}
